module.exports = {"attributes":{"height":"20","width":"20"},"content":"<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#6cbe99\"/>"}